import { createSlice } from "@reduxjs/toolkit";

const historySlice = createSlice({
  name: "history",
  initialState: [],
  reducers: {
    historyAdded(state, action) {
      return action.payload ?? [];
    },
    historyDeleted(state, action) {
      const historyId = action.payload.historyId;
      return state.filter(item => item.id !== historyId);
    },
    historyAddedSingle(state, action) {
      if (!action.payload || action.payload.length === 0) {
        return state; // Return the current state unchanged if the payload is empty
      } else {
        return [action.payload, ...state]; // Adds the new object to the existing state array
      }
    },
    historyStatusUpdateAction(state, action) {
      const historyId = action.payload.historyId;
      const value = action.payload.value;
      const historyIndex = state.findIndex(item => item.id === historyId);
      if (historyIndex !== -1) {
        state[historyIndex].status = value;
      }
    },
    historyObjectUpdate(state, action) {
      const historyId = action.payload.historyId;
      const value = action.payload.value;
      const historyIndex = state.findIndex(item => item.id === historyId);
      if (historyIndex !== -1) {
        state[historyIndex] = value;
      }
    },
    historyFileAdded(state, action) {
      const file = action.payload.response;
      const historyId = action.payload.historyId;

      const inspIndex = state.findIndex(item => item.id === historyId);
      if (inspIndex !== -1) {
        if (Array.isArray(state[inspIndex].images)) {
          state[inspIndex].images.push(file);
        } else {
          state[inspIndex].images = [file];
        }
      }
    },
    historyFileDelete(state, action) {
      const file = action.payload.file;
      const historyId = action.payload.historyId;

      const history = state.find(item => item.id === historyId);
      if (history?.images) {
        history.images = history.images.filter(image => image.id !== file.id);
      }
    },
  },
});

export const {
  historyAdded,
  historyDeleted,
  historyAddedSingle,
  historyStatusUpdateAction,
  historyObjectUpdate,
  historyFileAdded,
  historyFileDelete,
} = historySlice.actions;
export default historySlice.reducer;
